import { render, staticRenderFns } from "./memberLinkageExportFull.vue?vue&type=template&id=15a2c6c5&lang=pug"
import script from "./memberLinkageExportFull.vue?vue&type=script&lang=js"
export * from "./memberLinkageExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports